import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import t from "../helpers/t";
// @ts-ignore
import { Biscuit } from "../../utils";
// @ts-ignore
import { moment, $ } from "../../../vendor";
// @ts-ignore
import Loader from "./Loader";
import Switchpaddle from "./switchpaddle";
// @ts-ignore
import UsersSelect from "./Select/UsersSelect";
import FormItem from "./FormItem";
//import * as Function from "../pages/tasks/components/Functions";

const MultiEditDialog = ({
  handleCloseDialog,
  fields,
  fieldTypes,
  selectFields,
  selectedIds,
  entities,
  setEntities,
  setShouldSave,
  fieldLabels,
  dispatch,
  hasSuperSelect = null,
}: any) => {
  const [selected, setSelected] = useState(function () {
    let f: any = {};
    fields.map((field: any) => {
      f[field] = false;
    });
    return f;
  });
  const [fakeEntity, setFakeEntity] = useState(function () {
    if (hasSuperSelect !== null) {
      let r: any = {};
      Object.keys(hasSuperSelect).map((fa) => {
        r[fa] = [];
      });
      return r;
    }
  });
  const [toSave, setToSave] = useState(null);
  const [empty, setEmpty] = useState(true);
  const [selectedDate, setSelectedDate] = useState(function () {
    let resp: any = {};
    fields.map((fie: any) => {
      if (fieldTypes[fie] === "date") {
        resp[fie] = new Date();
      }
    });
    return resp;
  });
  const [fieldState, setFieldState] = useState(function () {
    let same: any = {};
    fields.map((fie: any) => {
      same[fie] = { value: null, same: false };
    });
    let toSet: any = [];
    entities.map((entity: any) => {
      if (typeof selectedIds[entity.id] !== "undefined" && selectedIds[entity.id]) {
        toSet.push(entity);
      }
    });
    let fieMap: any = {};
    if (toSet.length > 0) {
      fields.map((fie: any) => {
        same[fie] = { value: toSet[0][fie], same: toSet[0][fie] !== null };
      });
      toSet.map((s: any) => {
        fields.map((fie: any) => {
          if (s[fie] !== same[fie].value && s[fie] !== null) {
            same[fie].same = false;
          }
        });
      });
    }
    let clone: any = {};
    Object.assign(clone, selected);
    let resp: any = {};
    Object.keys(same).map((k: string) => {
      if (same[k].same) {
        clone[k] = true;
        // setSelected(clone);
        if (fieldTypes[k] === "select") {
          if (
            hasSuperSelect !== null &&
            typeof hasSuperSelect[k] !== "undefined" &&
            hasSuperSelect[k] === "User"
          ) {
            let clone2: any = {};
            Object.assign(clone2, fakeEntity);
            clone2[k] = {
              id: same[k].value,
              name: toSet[0].user.last_name + ", " + toSet[0].user.first_name,
            };
            setFakeEntity(clone2);
            resp[k] = true;
          } else {
            resp[k] = same[k].value;
          }
        }
        if (fieldTypes[k] === "bool") {
          resp[k] = same[k].value;
        }
        if (fieldTypes[k] === "date") {
          let clone2: any = {};
          Object.assign(clone2, selectedDate);
          clone2[k] = new Date(same[k].value);
          setSelectedDate(clone2);
          resp[k] = new Date(same[k].value);
        }
        if (fieldTypes[k] === "input") {
          resp[k] = same[k].value;
        }
      }
    });

    return resp;
  });

  useEffect(() => {
    Object.keys(fakeEntity).map((fi) => {
      if (typeof fakeEntity[fi][0] !== "undefined") {
        change(fakeEntity[fi][0].id, fi);
        setEmpty(false);
      } else {
        change(null, fi);
      }
    });
  }, [fakeEntity]);

  const changeSelect = (e: any) => {
    let clone: any = {};
    Object.assign(clone, selected);
    fields.map((field: any) => {
      if (e.target.name === field) {
        clone[field] = e.target.checked;
      }
    });
    setSelected(clone);
  };

  const changeField = (e: any) => {
    let clone: any = {};
    Object.assign(clone, fieldState);
    clone[e.target.name] = fieldTypes[e.target.name] === "bool" ? e.target.checked : e.target.value;
    setFieldState(clone);
    change(fieldTypes[e.target.name] === "bool" ? e.target.checked : e.target.value, e.target.name);
    setEmpty(false);
  };

  const change = (detail: any, field: any) => {
    if (typeof detail !== "undefined" && detail !== null) {
      let clone: any = {};
      clone[field] = detail;
      let clone2: any = {};
      Object.assign(clone2, selected);
      clone2[field] = true;
      setSelected(clone2);
      setToSave(clone);
    }
  };

  const close = () => {
    handleCloseDialog();
  };

  const save = () => {
    if (toSave !== null) {
      let clone: any = {};
      Object.assign(clone, entities);
      console.log(toSave);
      console.log(selected);
      Object.keys(selected).map((key) => {
        console.log("key", key);
        Object.keys(toSave).map((field) => {
          console.log("field", field);
          let detail = toSave[field];
          console.log("detail", detail);
          if (selected[key] && key === field) {
            console.log("inside");
            console.log(typeof clone === "object");
            if (typeof clone === "object") {
              Object.keys(clone).map((n) => {
                console.log(selectedIds);
                console.log(clone[n].id);
                console.log(selectedIds[clone[n].id]);
                if (typeof selectedIds[clone[n].id] !== "undefined" && selectedIds[clone[n].id]) {
                  clone[n][key] = detail;
                }
              });
            } else {
              clone.map((en: any, n: any) => {
                if (typeof selectedIds[en.id] !== "undefined" && selectedIds[en.id]) {
                  clone[n][key] = detail;
                }
              });
            }
          }
        });
      });
      setEntities(clone);
      setShouldSave(true);
    }
    close();
  };

  const changeDate = (date: any, field: any) => {
    let clone: any = {};
    Object.assign(clone, selectedDate);
    clone[field] = date;
    setSelectedDate(clone);
    setEmpty(false);
    change(moment(date).format("YYYY-MM-DD") + " 23:59:59", field);
  };

  return (
    <>
      {selected && (
        <>
          <Dialog
            onClose={close}
            aria-labelledby="changelogs-dialog-title"
            open={true}
            //  name="changeLogsDialog"
            id="multipleRecipientsDialog"
            maxWidth={"md"}
          >
            <header className="inb-multiple-recipients-header">
              <button
                onClick={handleCloseDialog}
                type="button"
                id="inb-multiple-recipients-dialog-close-button"
                className="button hollow secondary right button-close-multiple-recipients-dialog round"
                title={t("close multi edit")}
              >
                <i className="fi fi-x"></i>
              </button>
              {!empty && (
                <>
                  <button
                    onClick={save}
                    type="button"
                    id="inb-multiple-recipients-dialog-save-button"
                    className={
                      "button beautify beautify-" + Biscuit.get("user.client_id") + " round right"
                    }
                    style={{ marginRight: "10px" }}
                    title={t("save", null, "capital")}
                  >
                    <i className="fi fi-check"></i>
                    <span style={{ paddingLeft: "8px" }}>{t("save", null, "capital")}</span>
                  </button>
                </>
              )}
              <h1 className="inb-page-title" style={{ paddingLeft: "0" }}>
                {t("multi edit", null, "capital")}
              </h1>

              {/* <label className="inb-form__controlLabel legendLabel"><a href="#"
                                                                        onClick={(e) => _showPopUp(e, 'voucher for temporary user')}><i
                className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i></a></label>*/}
            </header>
            <div
              id="inb-c-main-multiple-recipients"
              className="inb-c-listing off-canvas-content"
              data-off-canvas-content=""
            >
              {selected ? (
                <>
                  {fields.map((field: any) => {
                    return (
                      <>
                        <div className="large-9 medium-9 small-12 row">
                          <Switchpaddle
                            name={field}
                            value={selected[field]}
                            largeWidth={1}
                            mediumWidth={1}
                            smallWidth={3}
                            paddle={false}
                            onChange={changeSelect}
                            label={""}
                          />
                          <label className="column large-3 medium-3 small-6 inb-form__controlLabel">
                            {fieldLabels[field]}
                          </label>
                          {fieldTypes[field] === "select" && (
                            <>
                              {hasSuperSelect !== null &&
                              typeof hasSuperSelect[field] !== "undefined" ? (
                                <>
                                  {hasSuperSelect[field] === "User" && (
                                    <UsersSelect
                                      entity={fakeEntity}
                                      setEntity={setFakeEntity}
                                      field={field}
                                      name={field}
                                      label={""}
                                      dispatch={dispatch}
                                      multi={false}
                                      largeWidth={6}
                                      mediumWidth={6}
                                      smallWidth={12}
                                    />
                                  )}
                                </>
                              ) : (
                                <>
                                  <label className="inb-form__controlLabel"></label>
                                  <div
                                    className="inb-form__controllClass"
                                    style={{ paddingLeft: "15px" }}
                                  >
                                    <select
                                      onChange={changeField}
                                      name={field}
                                      className="column large-6 medium-6 small-12"
                                      style={{
                                        minWidth: "200px",
                                        paddingLeft: "8px",
                                        paddingRight: "25px",
                                      }}
                                    >
                                      {selectFields[field].map((option: any) => {
                                        return (
                                          <>
                                            {typeof fieldState[field] !== "undefined" &&
                                            option.key === fieldState[field] ? (
                                              <>
                                                <option
                                                  selected={true}
                                                  key={option.key}
                                                  value={option.key}
                                                >
                                                  {option.label}
                                                </option>
                                              </>
                                            ) : (
                                              <>
                                                <option key={option.key} value={option.key}>
                                                  {option.label}
                                                </option>
                                              </>
                                            )}
                                          </>
                                        );
                                      })}
                                    </select>
                                  </div>
                                </>
                              )}
                            </>
                          )}
                          {fieldTypes[field] === "bool" && (
                            <>
                              <Switchpaddle
                                name={field}
                                value={
                                  typeof fieldState[field] !== "undefined"
                                    ? fieldState[field]
                                    : false
                                }
                                onChange={changeField}
                                largeWidth={1}
                                mediumWidth={1}
                                smallWidth={2}
                                label={""}
                              />
                            </>
                          )}
                          {fieldTypes[field] === "input" && (
                            <>
                              <input
                                type="text"
                                name={field}
                                onChange={changeField}
                                className="column large-6 medium-6 small-12"
                                value={
                                  typeof fieldState[field] !== "undefined" ? fieldState[field] : ""
                                }
                              />
                            </>
                          )}
                          {fieldTypes[field] === "date" && (
                            <>
                              <FormItem
                                name={field}
                                type="datePicker"
                                label={""}
                                placeholder=""
                                selected={selectedDate[field]}
                                dateFormat="dd.MM.y"
                                datePickerClass="noBorders-noBackground"
                                onChangeHandler={changeDate}
                                withName={true}
                                largeWidth={3}
                                mediumWidth={3}
                                smallWidth={6}
                                style={{ maxWidth: "230px" }}
                                extraTopClasses=""
                              />
                            </>
                          )}
                        </div>
                      </>
                    );
                  })}
                </>
              ) : (
                <>
                  {" "}
                  <Loader mediumWidth={6} smallWidth={6} subLoaders={0} />
                </>
              )}
            </div>
          </Dialog>
        </>
      )}
    </>
  );
};

export default MultiEditDialog;
